'use client';

import { Button } from '@ahafood/ui/components/button';
import { Image } from '@ahafood/ui/components/image';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { trackEvent } from '@/lib/event-tracking';

export default function ForYouHeader() {
  const router = useRouter();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBackButtonClick = () => {
    trackEvent('click_button', {
      action_time: Math.floor(Date.now() / 1000),
      button_name: 'is_back',
      button_location: 'for_you_zone',
    });
    router.back();
  };

  return (
    <div
      className={`${isScrolled ? 'bg-white/60 shadow-[0_8px_32px_rgba(0,0,0,0.3)]' : 'bg-white/10'} backdrop-blur-xl border-b border-white overflow-hidden transition-all duration-500 fixed top-0 inset-x-0 z-50 w-full max-w-screen-xl mx-auto`}
    >
      {/* Header Banner */}
      <div className="relative h-fit overflow-hidden rounded-b-[24px] flex items-center justify-between p-4">
        {/* Back Button */}
        <Button
          variant="ghost"
          // size="icon"
          className="flex items-center size-9 text-xl font-bold bg-neutral-30 hover:bg-neutral-40 rounded-full [&_svg]:stroke-2 [&_svg]:text-white backdrop-blur-md shadow-xl hover:scale-110 transition-transform mr-4"
          onClick={handleBackButtonClick}
        >
          <ChevronLeft />
        </Button>

        {/* Content */}
        <div className="relative h-full flex items-center">
          <div className="flex-1">
            <div className="gap-2 mb-1 flex flex-nowrap">
              <h1 className="text-xl font-[900] text-[#0D4073] h-[28px] whitespace-nowrap">
                FOR YOU
              </h1>{' '}
              <Image
                src="/static/icons/ai-gen.svg"
                alt="Ai"
                width={28}
                height={28}
                className="object-contain"
              />
            </div>
            <p className="text-neutral-60 font-medium">
              <span className="text-primary-50 font-bold">AI gợi ý</span> theo
              sở thích của bạn
            </p>
          </div>

          {/* Food Bowl Image */}
          <div className="relative shrink-0 w-[160px] h-20">
            <Image
              src="/static/images/for-you-header.webp"
              alt="AI Food Suggestions"
              fill
              className="object-contain"
              sizes="160px"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
